import { DashboardContext } from '../containers/DashBoardContext';
import { useContext } from 'react';

export function useDashboardContext() {
  const contextState = useContext(DashboardContext);

  return {
    patients: contextState.patients,
    selectedPatient: contextState.selectedPatient,
    selectedID: contextState.selectedID,
    changeID: contextState.changeID,
    downloadedExercises: contextState.downloadedExercises,
    changePatients: contextState.changePatients,
    changeSelectedPatient: contextState.changeSelectedPatient,
    fetchPatients: contextState.fetchPatients,
    fetchPatientsWrapper: contextState.fetchPatientsWrapper,
    patientsSyncing: contextState.patientsSyncing,
    showAssetDownloadModal: contextState.showAssetDownloadModal,
    assetDownloadProgress: contextState.assetDownloadProgress,
    setShowStorageWarningModal: contextState.setShowStorageWarningModal,
    changeShowAssetDownloadModal: contextState.changeShowAssetDownloadModal,
    changeAssetDownloadProgress: contextState.changeAssetDownloadProgress,
    mounted: contextState.mounted,
    downloadAssetsOnMobilePlatforms:
      contextState.downloadAssetsOnMobilePlatforms,
    toggleRefreshOnCopySets: contextState.toggleRefreshOnCopySets,
    setAllowefreshOnCopySets: contextState.setAllowefreshOnCopySets,
  };
}
